import {
  cityFactor,
  defaultRoadsEfficacy,
  highwayFactor,
  roadFactor,
} from "constants/driving-styles";
import { Car, Charger, RoadsStatus } from "shared-types";

export const acvalue = (ac: boolean) => (ac ? 1 : 0);

export const acFlow = (temperature: number, acvalue: number) => {
  if (acvalue) {
    switch (temperature) {
      case -10:
        return 1.468619247;
      case -5:
        return 1.314606742;
      case 0:
        return 1.214532872;
      case 5:
        return 1.166112957;
      case 10:
        return 1.107255521;
      case 15:
        return 1.029325513;
      case 20:
        return 1;
      case 25:
        return 1.020348837;
      case 30:
        return 1.10031348;
      default:
        return 0;
    }
  }
  switch (temperature) {
    case -10:
      return 1.214532872;
    case -5:
      return 1.162251656;
    case 0:
      return 1.114285714;
    case 5:
      return 1.070121951;
    case 10:
      return 1.03539823;
    case 15:
      return 1;
    case 20:
      return 0.96961326;
    case 25:
      return 0.941018767;
    case 30:
      return 0.95640327;
    default:
      return 0;
  }
};

export const roadTypeEff = (
  road: RoadsStatus,
  city: RoadsStatus,
  highway: RoadsStatus
) => {
  if (!road.isChosen && !city.isChosen && !highway.isChosen)
    return defaultRoadsEfficacy;

  const roadEff = road.percentage * roadFactor;
  const cityEff = city.percentage * cityFactor;
  const highwayEff = highway.percentage * highwayFactor;

  return 1 / (roadEff + cityEff + highwayEff);
};

export const calculateChargingTime = (
  selectedBatteryEntryLvl: number,
  selectedBatteryTargetLvl: number,
  selectedChargingMethod: Charger,
  selectedCar: Car
) => {
  /* Calculating battery capacity / current */
  const targetKwh = selectedBatteryTargetLvl * 0.01 * selectedCar.power;
  const currentKwhOfbatteryCapacity =
    selectedBatteryEntryLvl * 0.01 * selectedCar.power;
  const kwh = targetKwh - currentKwhOfbatteryCapacity;

  /* Calculating time estimation */
  const kw = selectedChargingMethod.power;
  let hours = kwh / kw;

  let hour = Math.floor(hours);
  let minutes = Math.floor((hours * 60) % 60);

  hour = isFinite(hour) ? hour : (hour = 0);
  minutes = isNaN(minutes) ? (minutes = 0) : minutes;

  return `${hour}:${
    minutes.toString().length === 1 ? "0" + minutes : minutes
  } h`;
};
